import headd from './myhead.vue'
const myhead = {
  install: (Vue) => {
    Vue.component('myhead', headd)
  }
}
export default myhead



//////////////////
// WEBPACK FOOTER
// ./src/components/Myhead/index.js
// module id = null
// module chunks = 